import * as Control$dPromise from "../Control.Promise/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dUncurried from "../Effect.Uncurried/index.js";
import {_hideModalBs5, _showModalBs5} from "./foreign.js";
const showModalBs5 = /* #__PURE__ */ (() => {
  const $0 = Effect$dUncurried.runEffectFn1(_showModalBs5);
  return x => Effect$dAff._bind(Effect$dAff._liftEffect($0(x)))(Control$dPromise.toAff$p(Control$dPromise.coerce));
})();
const hideModalBs5 = /* #__PURE__ */ (() => {
  const $0 = Effect$dUncurried.runEffectFn1(_hideModalBs5);
  return x => Effect$dAff._bind(Effect$dAff._liftEffect($0(x)))(Control$dPromise.toAff$p(Control$dPromise.coerce));
})();
export {hideModalBs5, showModalBs5};
export * from "./foreign.js";
